import moment from 'moment';

/**
 * 랜더링할 판매기간 데이터 반환
 * 우선순위: 타임딜 > 기획전 > 일반
 * 세가지 데이터가 딜인포에 존재, 추후 노출 우선순위에 따른 판매기간 노출 타입 및 데이터 내려받는 형태로 개선되면 좋을 것 같음
 */
export function getRenderPeriodData() {
  const {
    isTimeSchedule,
    timeScheduleInfoList,
    dealNo,
    planningViewStartDate,
    planningViewEndDate,
    isPermanentSales,
    endDate,
  } = TMON.oApp.htStorage.htStaticData.htDealInfo;

  // 타임딜
  if (
    isTimeSchedule === true &&
    timeScheduleInfoList &&
    timeScheduleInfoList.length !== 0
  ) {
    const scheduleShowType = timeScheduleInfoList[0];
    const { startDate: start, endDate: end } = timeScheduleInfoList[0];
    const dealStartTime = moment(start);
    const dealEndTime = moment(end);

    return {
      type: 'time',
      data: {
        scheduleShowType,
        dealStartTime,
        dealEndTime,
        dealNo,
      },
    };
  }

  // 기획전
  if (planningViewStartDate && planningViewEndDate) {
    const currentTime = moment(TMON.currentTimeTimestamp, 'x');
    const endTime = moment(planningViewEndDate, 'YYYY-MM-DD HH:mm:ss');
    const htDays = endTime.diff(currentTime, 'days');
    // 기획전 딜 시간이 남았는지 체크 0초보다 많고 3일보다 적을 때
    if (endTime.diff(currentTime, 'seconds') > 0 && htDays < 3) {
      return {
        type: 'plan',
        data: {
          currentTime,
          endTime,
          htDays,
        },
      };
    }
  }

  // 일반딜
  return {
    type: 'normal',
    data: {
      isPermanentSales,
      endDate,
    },
  };
}
